(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reset-coach-storefront"] && !Shopify.designMode) return;
  try {
    

  document.querySelectorAll('.reset-collection').forEach((section) => {

    if (section.dataset.ready === 'true') return;

    section.dataset.ready = 'true';

    const sort = section.querySelector('[data-sort]');

    const form = section.querySelector('.reset-collection__sort-form');

    sort?.addEventListener('change', () => form?.requestSubmit());

  });





  (() => {

    const money = (cents) => { try { return new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format((Number(cents)||0)/100); } catch (_) { return `₹${Math.round((Number(cents)||0)/100).toLocaleString('en-IN')}`; } };

    document.querySelectorAll('.reset-main-collection-section .reset-collection').forEach((section) => {

      if(section.dataset.quickCartReady==='true') return; section.dataset.quickCartReady='true';

      const dialog=section.querySelector('[data-quick-cart-dialog]'); if(!(dialog instanceof HTMLDialogElement)) return;

      const image=dialog.querySelector('[data-quick-image]'), title=dialog.querySelector('[data-quick-title]'), price=dialog.querySelector('[data-quick-price]'), compare=dialog.querySelector('[data-quick-compare]'), descriptionRoot=dialog.querySelector('[data-quick-description-output]'), optionsRoot=dialog.querySelector('[data-quick-options]'), benefitsRoot=dialog.querySelector('[data-quick-benefits-output]'), addButton=dialog.querySelector('[data-quick-add]'), details=dialog.querySelector('[data-quick-details]'), error=dialog.querySelector('[data-quick-error]');

      let state=null;

      const selectedVariant=()=>{if(!state)return null;if(!state.optionNames.length)return state.product.variants.find(v=>v.available)||state.product.variants[0]||null;return state.product.variants.find(v=>v.options.every((x,i)=>state.selected[i]===x))||null;};

      const salePrice=(v)=>{const raw=Number(v?.price||0);return state?.discountEnabled?Math.round(raw*(100-state.discountPercentage)/100):raw};

      const update=()=>{if(!state)return;optionsRoot.querySelectorAll('[data-option-value]').forEach(b=>{const i=Number(b.dataset.optionIndex),val=b.dataset.optionValue;b.setAttribute('aria-pressed',state.selected[i]===val?'true':'false');b.disabled=!state.product.variants.some(v=>v.available&&v.options.every((x,j)=>j===i?x===val:(!state.selected[j]||x===state.selected[j]))) });const v=selectedVariant(),all=state.optionNames.every((_,i)=>!!state.selected[i]);const shown=v||state.product.variants.find(x=>x.available)||state.product.variants[0];price.textContent=money(salePrice(shown));const cmp=state.discountEnabled?Number(shown?.price||0):Number(shown?.compare_at_price||0);compare.hidden=!(cmp>salePrice(shown));if(!compare.hidden)compare.textContent=money(cmp);addButton.disabled=!all||!v?.available;addButton.textContent=!all?'Select options':(!v?.available?'Sold out':'Add to cart');};

      const open=(card)=>{let product;try{product=JSON.parse(card.querySelector('[data-quick-product-json]').textContent)}catch(_){return}const preferredId=Number(card.dataset.preferredVariantId||0);const first=product.variants.find(v=>Number(v.id)===preferredId&&v.available)||product.variants.find(v=>v.available)||product.variants[0];const optionNames=(Array.isArray(product.options)?product.options:[]).map(o=>typeof o==='string'?o:o?.name).filter(Boolean);const defaultOnly=product.variants.length===1&&first?.options?.[0]==='Default Title';state={card,product,optionNames:defaultOnly?[]:optionNames,selected:defaultOnly?[]:[...(first?.options||[])],discountEnabled:card.dataset.discountEnabled==='true',discountPercentage:Number(card.dataset.discountPercentage||0)};title.textContent=product.title||'';details.href=card.dataset.productUrl||'#';image.src=first?.featured_image?.src||product.featured_image||product.images?.[0]||'';image.alt=product.title||'';descriptionRoot.innerHTML=card.querySelector('[data-quick-description]')?.innerHTML||'';benefitsRoot.innerHTML=card.querySelector('[data-quick-benefits]')?.innerHTML||'';error.hidden=true;optionsRoot.replaceChildren();if(!defaultOnly&&product.variants.length===1){state.selected=[...(first?.options||[])]}else if(!defaultOnly){optionNames.forEach((optionName,i)=>{const optionValues=[...new Set(product.variants.map(v=>v.options?.[i]).filter(Boolean))];const group=document.createElement('div');group.className='reset-quick-cart__option';group.innerHTML='<p class="reset-quick-cart__option-label"></p><div class="reset-quick-cart__values"></div>';group.querySelector('p').textContent=optionName;const vals=group.querySelector('div');optionValues.forEach(val=>{const b=document.createElement('button');b.type='button';b.className='reset-quick-cart__value';b.textContent=val;b.dataset.optionIndex=String(i);b.dataset.optionValue=val;b.setAttribute('aria-pressed','false');b.onclick=()=>{state.selected[i]=val;error.hidden=true;update()};vals.append(b)});optionsRoot.append(group)})}update();dialog.showModal()};



      section.addEventListener('click',e=>{const t=e.target.closest('[data-quick-cart-open]');if(!t)return;const card=t.closest('[data-card]');if(card){e.preventDefault();open(card)}});dialog.querySelector('[data-quick-cart-close]')?.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});

      addButton?.addEventListener('click', async () => {
        const v = selectedVariant();
        if (!state || !v?.available) return;
        addButton.disabled = true;
        addButton.textContent = 'Adding…';
        error.hidden = true;
        try {
          const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
          const code = (section.dataset.coachDiscountCode || 'NISHANT').trim();
          const productId = String(state.product.id);
          const variantId = String(v.id);
          const ids = [...new Set(Array.from(document.querySelectorAll('cart-items-component'))
            .map(item => item instanceof HTMLElement ? item.dataset.sectionId : null)
            .filter(Boolean))];

          // First add the item. Do not notify Dwell until the discount request finishes.
          const fd = new FormData();
          fd.append('id', variantId);
          fd.append('quantity', '1');
          const addResponse = await fetch(root + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd
          });
          const added = await addResponse.json();
          if (!addResponse.ok || added?.status) {
            throw new Error(added?.description || added?.message || 'Could not add this product to cart.');
          }

          let cartData = null;
          let sections = {};
          if (code) {
            // This exact discount field was verified by the on-page diagnostic.
            const discountResponse = await fetch(root + 'cart/update.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: code, ...(ids.length ? { sections: ids } : {}) })
            });
            cartData = await discountResponse.json();
            if (!discountResponse.ok) {
              throw new Error(cartData?.description || cartData?.message || 'Could not apply coach discount.');
            }
            const applied = (cartData.discount_codes || []).some(d =>
              d.code?.toLowerCase() === code.toLowerCase() && d.applicable === true);
            if (!applied) console.warn('Coach discount not applicable to this cart', cartData.discount_codes);
            sections = cartData.sections || {};
          }
          if (!Object.keys(sections).length && ids.length) {
            const sectionResponse = await fetch(root + '?sections=' + encodeURIComponent(ids.join(',')), {
              credentials: 'same-origin'
            });
            if (sectionResponse.ok) sections = await sectionResponse.json();
          }

          dialog.close();
          // Dwell's native cart listener receives the final post-discount sections.
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
            resource: cartData || {}, sourceId: variantId,
            data: { source: 'product-form-component', itemCount: 1, productId, variantId, sections }
          }}));
          addButton.textContent = 'Added ✓';
        } catch (err) {
          error.textContent = err?.message || 'Something went wrong. Please try again.';
          error.hidden = false;
          addButton.textContent = 'Add to cart';
        } finally {
          addButton.disabled = false;
        }
      });

    });

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reset-main-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.reset-collection').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    const sort = section.querySelector('[data-sort]');
    const form = section.querySelector('.reset-collection__sort-form');
    sort?.addEventListener('change', () => form?.requestSubmit());
  });


  (() => {
    const money = (cents) => { try { return new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format((Number(cents)||0)/100); } catch (_) { return `₹${Math.round((Number(cents)||0)/100).toLocaleString('en-IN')}`; } };
    document.querySelectorAll('.reset-main-collection-section .reset-collection').forEach((section) => {
      if(section.dataset.quickCartReady==='true') return; section.dataset.quickCartReady='true';
      const dialog=section.querySelector('[data-quick-cart-dialog]'); if(!(dialog instanceof HTMLDialogElement)) return;
      const image=dialog.querySelector('[data-quick-image]'), title=dialog.querySelector('[data-quick-title]'), price=dialog.querySelector('[data-quick-price]'), compare=dialog.querySelector('[data-quick-compare]'), descriptionRoot=dialog.querySelector('[data-quick-description-output]'), optionsRoot=dialog.querySelector('[data-quick-options]'), benefitsRoot=dialog.querySelector('[data-quick-benefits-output]'), addButton=dialog.querySelector('[data-quick-add]'), details=dialog.querySelector('[data-quick-details]'), error=dialog.querySelector('[data-quick-error]');
      let state=null;
      const selectedVariant=()=>{if(!state)return null;if(!state.optionNames.length)return state.product.variants.find(v=>v.available)||state.product.variants[0]||null;return state.product.variants.find(v=>v.options.every((x,i)=>state.selected[i]===x))||null;};
      const salePrice=(v)=>{const raw=Number(v?.price||0);return state?.discountEnabled?Math.round(raw*(100-state.discountPercentage)/100):raw};
      const update=()=>{if(!state)return;optionsRoot.querySelectorAll('[data-option-value]').forEach(b=>{const i=Number(b.dataset.optionIndex),val=b.dataset.optionValue;b.setAttribute('aria-pressed',state.selected[i]===val?'true':'false');b.disabled=!state.product.variants.some(v=>v.available&&v.options.every((x,j)=>j===i?x===val:(!state.selected[j]||x===state.selected[j]))) });const v=selectedVariant(),all=state.optionNames.every((_,i)=>!!state.selected[i]);const shown=v||state.product.variants.find(x=>x.available)||state.product.variants[0];price.textContent=money(salePrice(shown));const cmp=state.discountEnabled?Number(shown?.price||0):Number(shown?.compare_at_price||0);compare.hidden=!(cmp>salePrice(shown));if(!compare.hidden)compare.textContent=money(cmp);addButton.disabled=!all||!v?.available;addButton.textContent=!all?'Select options':(!v?.available?'Sold out':'Add to cart');};
      const open=(card)=>{let product;try{product=JSON.parse(card.querySelector('[data-quick-product-json]').textContent)}catch(_){return}const first=product.variants.find(v=>v.available)||product.variants[0];const optionNames=(Array.isArray(product.options)?product.options:[]).map(o=>typeof o==='string'?o:o?.name).filter(Boolean);const defaultOnly=product.variants.length===1&&first?.options?.[0]==='Default Title';state={card,product,optionNames:defaultOnly?[]:optionNames,selected:defaultOnly?[]:Array(optionNames.length).fill(''),discountEnabled:card.dataset.discountEnabled==='true',discountPercentage:Number(card.dataset.discountPercentage||0)};title.textContent=product.title||'';details.href=card.dataset.productUrl||'#';image.src=first?.featured_image?.src||product.featured_image||product.images?.[0]||'';image.alt=product.title||'';descriptionRoot.innerHTML=card.querySelector('[data-quick-description]')?.innerHTML||'';benefitsRoot.innerHTML=card.querySelector('[data-quick-benefits]')?.innerHTML||'';error.hidden=true;optionsRoot.replaceChildren();if(!defaultOnly&&product.variants.length===1){state.selected=[...(first?.options||[])]}else if(!defaultOnly){optionNames.forEach((optionName,i)=>{const optionValues=[...new Set(product.variants.map(v=>v.options?.[i]).filter(Boolean))];const group=document.createElement('div');group.className='reset-quick-cart__option';group.innerHTML='<p class="reset-quick-cart__option-label"></p><div class="reset-quick-cart__values"></div>';group.querySelector('p').textContent=optionName;const vals=group.querySelector('div');optionValues.forEach(val=>{const b=document.createElement('button');b.type='button';b.className='reset-quick-cart__value';b.textContent=val;b.dataset.optionIndex=String(i);b.dataset.optionValue=val;b.setAttribute('aria-pressed','false');b.onclick=()=>{state.selected[i]=val;error.hidden=true;update()};vals.append(b)});optionsRoot.append(group)})}update();dialog.showModal()};

      section.addEventListener('click',e=>{const t=e.target.closest('[data-quick-cart-open]');if(!t)return;const card=t.closest('[data-card]');if(card){e.preventDefault();open(card)}});dialog.querySelector('[data-quick-cart-close]')?.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});
      addButton?.addEventListener('click',async()=>{const v=selectedVariant();if(!state||!v?.available)return;addButton.disabled=true;addButton.textContent='Adding…';error.hidden=true;try{const fd=new FormData();fd.append('id',String(v.id));fd.append('quantity','1');const ids=[];document.querySelectorAll('cart-items-component').forEach(item=>{if(item instanceof HTMLElement&&item.dataset.sectionId)ids.push(item.dataset.sectionId)});if(ids.length)fd.append('sections',[...new Set(ids)].join(','));const root=window.Shopify?.routes?.root||'/';const res=await fetch(`${root}cart/add.js`,{method:'POST',headers:{Accept:'text/html'},body:fd});const result=await res.json();if(!res.ok||result?.status)throw new Error(result?.description||result?.message||'Could not add this product to cart.');dialog.close();document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:{},sourceId:String(v.id),data:{source:'product-form-component',itemCount:1,productId:String(state.product.id),variantId:String(v.id),sections:result.sections||{}}}}));addButton.textContent='Added ✓'}catch(err){error.textContent=err?.message||'Something went wrong. Please try again.';error.hidden=false;addButton.disabled=false;addButton.textContent='Add to cart'}});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reset-promo-popup"]) return;
  try {
    
  if (!customElements.get('reset-promo-popup')) {
    customElements.define('reset-promo-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.closeButtons = this.querySelectorAll('[data-popup-close]');
        this.storageKey = `resetPromoClosed-${this.id}`;
        this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });

        const enabled = this.dataset.enabled === 'true';
        const homepageAllowed = this.dataset.homepageOnly !== 'true' || this.dataset.isHomepage === 'true';
        const closedAt = Number(localStorage.getItem(this.storageKey) || 0);
        const frequencyMs = Number(this.dataset.frequency) * 60 * 60 * 1000;
        const eligible = !closedAt || Date.now() - closedAt >= frequencyMs;

        // Do not interrupt work in the Shopify theme editor.
        // Storefront display remains controlled by the existing settings.
        if (window.Shopify && Shopify.designMode) return;

        if (enabled && homepageAllowed && eligible) {
          window.setTimeout(() => this.open(), Number(this.dataset.delay));
        }
      }

      open() {
        this.hidden = false;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }

      close() {
        if (this.dialog.open) this.dialog.close();
        this.hidden = true;
        document.documentElement.style.overflow = '';
        if (!Shopify.designMode) localStorage.setItem(this.storageKey, String(Date.now()));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reset-what-people-love"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reset-people-love-slider')) {
    class ResetPeopleLoveSlider extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.track = this.querySelector('[data-track]');
        this.section = this.closest('.reset-people-love');
        this.previous = this.section?.querySelector('[data-previous]');
        this.next = this.section?.querySelector('[data-next]');
        this.dots = this.querySelector('[data-dots]');
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        if (!this.track || !this.cards.length) return;

        this.previous?.addEventListener('click', () => this.goToPage(this.currentPage - 1));
        this.next?.addEventListener('click', () => this.goToPage(this.currentPage + 1));
        this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goToPage(this.currentPage - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goToPage(this.currentPage + 1);
          }
        });

        this.resizeObserver = new ResizeObserver(() => this.setup());
        this.resizeObserver.observe(this.track);
        this.setup();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      get perPage() {
        if (window.matchMedia('(max-width: 749px)').matches) return 2;
        if (window.matchMedia('(max-width: 989px)').matches) return 3;
        return 4;
      }

      setup() {
        this.pageCount = Math.max(1, Math.ceil(this.cards.length / this.perPage));
        this.currentPage = Math.min(this.currentPage || 0, this.pageCount - 1);
        this.buildDots();
        this.updateControls();
      }

      buildDots() {
        if (!this.dots) return;
        this.dots.replaceChildren();
        for (let index = 0; index < this.pageCount; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'reset-people-love__dot';
          dot.setAttribute('aria-label', `Go to product page ${index + 1}`);
          dot.addEventListener('click', () => this.goToPage(index));
          this.dots.append(dot);
        }
        this.dots.hidden = this.pageCount <= 1;
      }

      goToPage(page) {
        const targetPage = Math.max(0, Math.min(page, this.pageCount - 1));
        const card = this.cards[targetPage * this.perPage];
        if (!card) return;
        this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }

      requestUpdate() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateControls());
      }

      updateControls() {
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const ratio = maxScroll ? this.track.scrollLeft / maxScroll : 0;
        this.currentPage = Math.max(0, Math.min(this.pageCount - 1, Math.round(ratio * (this.pageCount - 1))));
        if (this.previous) {
          this.previous.hidden = this.pageCount <= 1;
          this.previous.disabled = this.currentPage === 0;
        }
        if (this.next) {
          this.next.hidden = this.pageCount <= 1;
          this.next.disabled = this.currentPage === this.pageCount - 1;
        }
        this.dots?.querySelectorAll('button').forEach((dot, index) => {
          dot.setAttribute('aria-current', index === this.currentPage ? 'true' : 'false');
        });
      }
    }

    customElements.define('reset-people-love-slider', ResetPeopleLoveSlider);
  }

  (() => {
    const money = (cents) => { try { return new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format((Number(cents)||0)/100); } catch (_) { return `₹${Math.round((Number(cents)||0)/100).toLocaleString('en-IN')}`; } };
    document.querySelectorAll('.reset-people-love').forEach((section) => {
      if(section.dataset.quickCartReady==='true') return; section.dataset.quickCartReady='true';
      const dialog=section.querySelector('[data-quick-cart-dialog]'); if(!(dialog instanceof HTMLDialogElement)) return;
      const image=dialog.querySelector('[data-quick-image]'), title=dialog.querySelector('[data-quick-title]'), price=dialog.querySelector('[data-quick-price]'), compare=dialog.querySelector('[data-quick-compare]'), descriptionRoot=dialog.querySelector('[data-quick-description-output]'), optionsRoot=dialog.querySelector('[data-quick-options]'), benefitsRoot=dialog.querySelector('[data-quick-benefits-output]'), addButton=dialog.querySelector('[data-quick-add]'), details=dialog.querySelector('[data-quick-details]'), error=dialog.querySelector('[data-quick-error]');
      let state=null;
      const selectedVariant=()=>{if(!state)return null;if(!state.optionNames.length)return state.product.variants.find(v=>v.available)||state.product.variants[0]||null;return state.product.variants.find(v=>v.options.every((x,i)=>state.selected[i]===x))||null;};
      const salePrice=(v)=>{const raw=Number(v?.price||0);return state?.discountEnabled?Math.round(raw*(100-state.discountPercentage)/100):raw};
      const update=()=>{if(!state)return;optionsRoot.querySelectorAll('[data-option-value]').forEach(b=>{const i=Number(b.dataset.optionIndex),val=b.dataset.optionValue;b.setAttribute('aria-pressed',state.selected[i]===val?'true':'false');b.disabled=!state.product.variants.some(v=>v.available&&v.options.every((x,j)=>j===i?x===val:(!state.selected[j]||x===state.selected[j]))) });const v=selectedVariant(),all=state.optionNames.every((_,i)=>!!state.selected[i]);const shown=v||state.product.variants.find(x=>x.available)||state.product.variants[0];price.textContent=money(salePrice(shown));const cmp=state.discountEnabled?Number(shown?.price||0):Number(shown?.compare_at_price||0);compare.hidden=!(cmp>salePrice(shown));if(!compare.hidden)compare.textContent=money(cmp);addButton.disabled=!all||!v?.available;addButton.textContent=!all?'Select options':(!v?.available?'Sold out':'Add to cart');};
      const open=(card)=>{let product;try{product=JSON.parse(card.querySelector('[data-quick-product-json]').textContent)}catch(_){return}const first=product.variants.find(v=>v.available)||product.variants[0];const optionNames=(Array.isArray(product.options)?product.options:[]).map(o=>typeof o==='string'?o:o?.name).filter(Boolean);const defaultOnly=product.variants.length===1&&first?.options?.[0]==='Default Title';state={card,product,optionNames:defaultOnly?[]:optionNames,selected:defaultOnly?[]:Array(optionNames.length).fill(''),discountEnabled:card.dataset.discountEnabled==='true',discountPercentage:Number(card.dataset.discountPercentage||0)};title.textContent=product.title||'';details.href=card.dataset.productUrl||'#';image.src=first?.featured_image?.src||product.featured_image||product.images?.[0]||'';image.alt=product.title||'';descriptionRoot.innerHTML=card.querySelector('[data-quick-description]')?.innerHTML||'';benefitsRoot.innerHTML=card.querySelector('[data-quick-benefits]')?.innerHTML||'';error.hidden=true;optionsRoot.replaceChildren();if(!defaultOnly&&product.variants.length===1){state.selected=[...(first?.options||[])]}else if(!defaultOnly){optionNames.forEach((optionName,i)=>{const optionValues=[...new Set(product.variants.map(v=>v.options?.[i]).filter(Boolean))];const group=document.createElement('div');group.className='reset-quick-cart__option';group.innerHTML='<p class="reset-quick-cart__option-label"></p><div class="reset-quick-cart__values"></div>';group.querySelector('p').textContent=optionName;const vals=group.querySelector('div');optionValues.forEach(val=>{const b=document.createElement('button');b.type='button';b.className='reset-quick-cart__value';b.textContent=val;b.dataset.optionIndex=String(i);b.dataset.optionValue=val;b.setAttribute('aria-pressed','false');b.onclick=()=>{state.selected[i]=val;error.hidden=true;update()};vals.append(b)});optionsRoot.append(group)})}update();dialog.showModal()};

      section.addEventListener('click',e=>{const t=e.target.closest('[data-quick-cart-open]');if(!t)return;const card=t.closest('[data-card]');if(card){e.preventDefault();open(card)}});dialog.querySelector('[data-quick-cart-close]')?.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});
      addButton?.addEventListener('click',async()=>{const v=selectedVariant();if(!state||!v?.available)return;addButton.disabled=true;addButton.textContent='Adding…';error.hidden=true;try{const fd=new FormData();fd.append('id',String(v.id));fd.append('quantity','1');const ids=[];document.querySelectorAll('cart-items-component').forEach(item=>{if(item instanceof HTMLElement&&item.dataset.sectionId)ids.push(item.dataset.sectionId)});if(ids.length)fd.append('sections',[...new Set(ids)].join(','));const root=window.Shopify?.routes?.root||'/';const res=await fetch(`${root}cart/add.js`,{method:'POST',headers:{Accept:'text/html'},body:fd});const result=await res.json();if(!res.ok||result?.status)throw new Error(result?.description||result?.message||'Could not add this product to cart.');dialog.close();document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:{},sourceId:String(v.id),data:{source:'product-form-component',itemCount:1,productId:String(state.product.id),variantId:String(v.id),sections:result.sections||{}}}}));addButton.textContent='Added ✓'}catch(err){error.textContent=err?.message||'Something went wrong. Please try again.';error.hidden=false;addButton.disabled=false;addButton.textContent='Add to cart'}});
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
